import { IInitOptions } from "../interfaces/initoptions";

export function getInitOptions(): IInitOptions {
    const setup: IInitOptions = (<any> window).initOptions;
    return setup;
}
